import $ from "jquery";

export const getTextinputBackgroundColor = (id: string) =>
  $(`#textinput-${id}`).css("background-color");
export const setTextinputBackgroundColor = (id: string, value: string) =>
  $(`#textinput-${id}`).css("background-color", `${value}`);
